<template>
  <div>
    <template v-if="column.type === 'date'">
      <i v-if="row[column.prop]" class="el-icon-date" />
      {{ row[column.prop] | formatDate }}
    </template>
    <template v-else-if="column.type === 'datetime'">
      <i v-if="row[column.prop]" class="el-icon-date" />
      {{ row[column.prop] | formatDateTime }}
    </template>
    <template v-else-if="column.type === 'datetime-without-timezone'">
      <i v-if="row[column.prop]" class="el-icon-date" />
      {{ row[column.prop] | formatDateTimeWithoutTimezone }}
    </template>
    <template v-else-if="column.type === 'bool'">
      <i v-if="row[column.prop] === true" class="el-icon el-icon-success" />
      <i v-else class="el-icon el-icon-error" />
    </template>
    <template v-else-if="column.type === 'enum'">
      <el-tooltip
        v-if="row[column.prop] && !column.hideTooltip"
        :content="row[column.prop]"
        placement="top"
      >
        <el-tag type="success" effect="plain" disable-transitions>{{
          normalizedEnum
        }}</el-tag>
      </el-tooltip>
      <el-tag
        v-else-if="normalizedEnum"
        type="success"
        effect="plain"
        disable-transitions
        >{{ normalizedEnum }}</el-tag
      >
    </template>
    <template v-else-if="column.type === 'preview'">
      <el-image
        v-if="row[column.prop]"
        :src="fullPath"
        :preview-src-list="[fullPath]"
        fit="contain"
        lazy
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline" />
        </div>
      </el-image>
    </template>
    <template v-else-if="column.type === 'fullPath'">
      {{ fullPath }}
    </template>
    <template v-else-if="column.type === 'audio'">
      <audio controls>
        <source :src="mediaUrl + '/' + row[column.prop]" />
      </audio>
    </template>
    <template v-else-if="column.type === 'color'">
      <span
        class="color-preview"
        :style="{
          backgroundColor: row[column.prop],
          borderColor: $options.filters.invertColor(row[column.prop], true),
          color: $options.filters.invertColor(row[column.prop], true),
        }"
      >
        {{ row[column.prop] }}
      </span>
    </template>
    <template v-else-if="column.type === 'deeplink'">
      <el-link :underline="false">
        <router-link
          href="`/api/deeplinks/personal/campaign/${row[column.prop]}/file.csv`"
          >Скачать</router-link
        >
      </el-link>
    </template>
    <template v-else-if="column.type === 'ext_link'">
      <a :href="row[column.prop]">{{ row[column.prop] | cplitFilePath }}</a>
    </template>
    <template v-else-if="column.type === 'ext_link_full'">
      <a :href="row[column.prop]">{{ row[column.prop] }}</a>
    </template>
    <template v-else-if="column.type === 'ext_link_media'">
      <button class="button-image-dialog" @click="toggleDialogImage(fullPath)">
        {{ fullPath }}
      </button>
    </template>
    <template v-else-if="column.type === 'download'">
      <el-link
        type="primary"
        @click="
          download(
            column.download,
            row[column.prop],
            row[column.filename_prop],
            column.ext
          )
        "
      >
        Скачать
      </el-link>
    </template>
    <template v-else-if="column.type === 'list'">
      <div class="list">
        <span v-for="(item, index) in row[column.prop]" :key="index">
          {{ item }}{{ index + 1 !== row[column.prop].length ? "," : "" }}
        </span>
      </div>
    </template>
    <template v-else-if="column.type === 'list-data'">
      <div class="list">
        <span v-for="(item, index) in listData" :key="index">
          {{ item }}{{ index + 1 !== listData.length ? "," : "" }}
        </span>
      </div>
    </template>
    <template v-else-if="column.type === 'meta'">
      <router-link :to="`meta/${row[column.prop]}`">
        <el-button icon="el-icon-info" size="mini">
          Редактировать мету
        </el-button>
      </router-link>
    </template>
    <template v-else>
      <el-link v-if="column.link" :underline="false">
        <router-link
          :to="`edit/${row[options.id] || row.id || row.plu || row.stockUID}`"
        >
          {{ row[column.prop] }}
        </router-link>
      </el-link>
      <template v-else>
        {{ row[column.prop] }}
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Message } from "element-ui";
import { enumFilter } from "@/utils/filters";

export default {
  name: "TableColumn",
  filters: {
    invertColor(value, bw) {
      let hex = value.indexOf("#") === 0 ? value.slice(1) : value;
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      if (hex.length !== 6) {
        return value;
      }
      let r = parseInt(hex.slice(0, 2), 16);
      let g = parseInt(hex.slice(2, 4), 16);
      let b = parseInt(hex.slice(4, 6), 16);
      if (bw) {
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
      }
      r = (255 - r).toString(16);
      g = (255 - g).toString(16);
      b = (255 - b).toString(16);
      const addZero = (value) => ("0" + value).slice(-2);
      return "#" + addZero(r) + addZero(g) + addZero(b);
    },
    cplitFilePath(path) {
      return path.split("/").pop();
    },
  },
  props: {
    column: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    data: {
      type: [Array, Object],
    },
  },
  data() {
    return {
      listData: [],
    };
  },
  mounted() {
    if (this.column.type === "list-data") {
      this.createListData();
    }
  },
  computed: {
    ...mapGetters(["mediaUrl"]),
    fullPath() {
      const path = this.row[this.column.prop];

      // если сервер возвращает полный путь к изображению, не добавляем mediaUrl
      if (path.indexOf("//") !== -1) {
        return path;
      }

      return `${this.mediaUrl}/${path}`;
    },
    normalizedEnum() {
      const name = this.column.alias || this.column.name || this.column.prop;
      const value = this.row[this.column.prop];

      return enumFilter(name, value);
    },
  },
  methods: {
    createListData() {
      this.row[this.column.prop].forEach((el) => {
        let find = this.data.find((e) => e.id == el);
        if (find) this.listData.push(find.name);
      });
    },
    enumFilter,
    async download(download, id, filename, ext) {
      const fileName = `${filename}.${ext}`;
      try {
        const data = await download(id);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // for IE
          window.navigator.msSaveOrOpenBlob(data, fileName);
        } else {
          // for Non-IE (chrome, firefox etc.)
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          document.body.appendChild(link);
          link.style = "display: none";
          link.download = fileName;
          link.href = url;
          link.click();
          URL.revokeObjectURL(link.href);
          link.remove();
        }
      } catch (error) {
        Message({
          message: `Файл не найден`,
          type: "warning",
          duration: 5e3,
        });
      }
    },
    toggleDialogImage(fullPath) {
      this.$store.dispatch("app/toggleDialogImage", fullPath);
    },
  },
};
</script>

<style scoped>
.el-icon {
  font-size: 18px;
}
.el-icon-success {
  color: #67c23a;
}
.el-icon-error {
  color: #ee2d24;
}
.el-icon-picture-outline {
  font-size: 26px;
  display: block;
  top: 2px;
  position: relative;
}
.el-image {
  height: 65px;
  display: block;
}
.color-preview {
  display: inline-block;
  padding: 5px 10px 3px 10px;
  border: 1px solid gray;
  border-radius: 5px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
}
.button-image-dialog {
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
</style>
